import { useEffect } from "react";
import { IonCol } from "@ionic/react";
import { FaVideo, FaVideoSlash } from "react-icons/fa";
import { DarkTooltip } from "./DarkTooltip";

export const SoundcloudPlayer = (props) => {
  const { isMobile, latestMix, handlePopupOpen, handlePopupClose, isVisible } =
    props;

  const tooltipText = isVisible
    ? "The visuals stay active until you interact with the page."
    : "Press for visuals. The visuals stay active until you interact with the page.";

  const handleClick = () => {
    if (isVisible) {
      handlePopupClose();
    } else {
      handlePopupOpen();
    }
  };

  useEffect(() => {
    const iframe = document.getElementById("sc-player");
    if (window.SC && iframe) {
      const widget = window.SC.Widget(iframe);
      widget.bind(window.SC.Widget.Events.PLAY, () => {
        handlePopupOpen();
      });
      widget.bind(window.SC.Widget.Events.PAUSE, () => {
        handlePopupClose();
      });
    }
  }, [handlePopupOpen, handlePopupClose]);

  return (
    <IonCol className="soundcloud-player">
      {!isMobile && (
        <DarkTooltip title={tooltipText}>
          <div onClick={handleClick} className="page-title-clickable">
            {isVisible ? <FaVideo /> : <FaVideoSlash color="#cac7c7" />}
          </div>
        </DarkTooltip>
      )}
      <iframe
        id="sc-player"
        src={latestMix}
        className="sc-frame"
        title="sc-frame"
        height="20"
        scrolling="no"
        loading="eager"
        decoding="async"
        fetchpriority="high"
        frameBorder={0}
      ></iframe>
    </IonCol>
  );
};
